var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.display)?_c('ShopNav'):_vm._e(),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }